import 'moment/locale/fr';
import 'react-datepicker/dist/react-datepicker.css';

import fr from 'date-fns/locale/fr';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import ReactDatePicker, { registerLocale } from 'react-datepicker';

import FieldTitle from '../../components/agv-forms-title';
import GenericModal from '../../components/agv-generic-modal';

registerLocale('fr', fr);

/**
 * Modale (Super-Admin) permettant de déclencher manuellement l'envoi du
 * récapitulatif des factures de tous les clients pour un mois donné.
 */
export default function SendSummaryModal({
  isOpen,
  setIsOpen,
  sendInvoicesSummary,
  isLoading,
}) {
  const [month, setMonth] = useState(null);

  useEffect(() => {
    if (isOpen) {
      // Par défaut : le mois précédent (cas d'usage le 1er du mois).
      setMonth(moment().subtract(1, 'month').toDate());
    } else {
      setMonth(null);
    }
  }, [isOpen]);

  const handleSend = async () => {
    if (!month || isLoading) return;
    const start = moment(month).startOf('month').format('YYYY-MM-DD');
    const end = moment(month).endOf('month').format('YYYY-MM-DD');
    await sendInvoicesSummary(start, end);
  };

  return (
    <GenericModal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      title={'Envoyer le récapitulatif des factures'}
      mainAction={handleSend}
      mainActionText={'Envoyer'}
      mainActionIsLoading={isLoading}
      mainActionDisabled={!month}
    >
      <div className="tw-flex tw-flex-col tw-pb-6 tw-gap-3">
        <p className="tw-text-sm tw-text-slate-600 tw-m-0">
          Sélectionnez le mois concerné. Le récapitulatif des factures de tous
          les clients sera envoyé par email aux Super-Admin.
        </p>
        <div>
          <FieldTitle title="Mois" />
          <ReactDatePicker
            selected={month}
            onChange={(date) => setMonth(date)}
            showMonthYearPicker
            dateFormat="MMMM yyyy"
            locale="fr"
            maxDate={new Date()}
            disabled={isLoading}
            className="tw-mt-2 tw-w-full tw-border tw-border-solid tw-border-slate-300 tw-rounded tw-px-3 tw-py-2 tw-text-sm"
          />
        </div>
        {month && (
          <p className="tw-text-sm tw-text-slate-700 tw-m-0">
            Période :{' '}
            <strong>
              {moment(month).startOf('month').format('DD/MM/YYYY')}
            </strong>{' '}
            au{' '}
            <strong>{moment(month).endOf('month').format('DD/MM/YYYY')}</strong>
          </p>
        )}
      </div>
    </GenericModal>
  );
}
